import React from "react";
import styles from "./Privacy.module.scss";

export const Mention = () => {
    return (
        <div className={styles.ComingSoon}>
            <h2>Coming Soon</h2>
        </div>
    );
};

export default Mention;


